import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

const items = ({ children }: { children: ReactNode }) => (
    <Box gap="8px" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }} alignItems="center">
        {children}
    </Box>
);

export default items;
